<div class="c-card--1 g--margin-t-15">

    <div class="c-card__body g--margin-b-30">

        <!-- Grupo Preferencias Perfil -->
        <ng-container *ngFor="let preferencia of preferencias">
            <div class="g--margin-t-30"
              *ngIf="preferencia.TipoProducto === 0 && preferencia.Visible && preferencia.Opciones !== null">
                <app-grupo-preferencia
                    #Grupo_Preferencia
                    [Id]="preferencia.Id"
                    [TituloGrupo]="preferencia.ClaveTraduccion"
                    [ListaPreferencias] = "preferencia.Opciones"
                    [RequiereObservacion]="true"
                    [multiple]="preferencia.SeleccionMultiple"
                    [required]="preferencia.Obligatorio"
                    [listaOtros]="listaOtros"> 
                </app-grupo-preferencia>
            </div>
        </ng-container>
        
    </div>
</div>
